(function () {
  var SELECTOR = '[data-vernal-multi-scene-intro]';
  var MOBILE_MEDIA_QUERY = '(max-width: 989px)';
  var TITLE_EQUALIZE_MQ = window.matchMedia('(min-width: 990px)');
  var ACTIVE_CLASS = 'is-mobile-active';
  var instances = new WeakMap();
  var titleImagesWithLoadHook = new WeakSet();
  var titleResizeTimer;
  var titleOtherTimer;

  function groupTitlesByRow(elements, tolerance) {
    var rows = [];
    elements.forEach(function (el) {
      var top = el.getBoundingClientRect().top;
      var bucket = null;
      for (var i = 0; i < rows.length; i++) {
        if (Math.abs(rows[i].top - top) <= tolerance) {
          bucket = rows[i];
          break;
        }
      }
      if (!bucket) {
        bucket = { top: top, els: [] };
        rows.push(bucket);
      }
      bucket.els.push(el);
    });
    return rows.map(function (r) {
      return r.els;
    });
  }

  function bindTitleImageLoads(root) {
    root.querySelectorAll('img').forEach(function (img) {
      if (titleImagesWithLoadHook.has(img)) return;
      titleImagesWithLoadHook.add(img);
      if (img.complete) return;
      img.addEventListener('load', scheduleTitleEqualize, { once: true });
      img.addEventListener('error', scheduleTitleEqualize, { once: true });
    });
  }

  function equalizeElementsByRow(elements) {
    elements.forEach(function (el) {
      el.style.minHeight = '';
    });
    if (elements.length === 0) return;

    // 强制回流后再量高，避免读到旧布局
    void elements[0].offsetHeight;

    groupTitlesByRow(elements, 5).forEach(function (group) {
      if (group.length <= 1) return;

      var maxH = 0;
      group.forEach(function (el) {
        var h = el.getBoundingClientRect().height;
        if (h > maxH) maxH = h;
      });
      var next = Math.ceil(maxH) + 'px';
      group.forEach(function (el) {
        if (el.style.minHeight !== next) {
          el.style.minHeight = next;
        }
      });
    });
  }

  function clearMinHeights(elements) {
    elements.forEach(function (el) {
      el.style.minHeight = '';
    });
  }

  function shouldEqualizeText(root) {
    if (TITLE_EQUALIZE_MQ.matches) return true;
    // 移动端轮播：横向卡片同行对齐标题/描述
    return root.hasAttribute('data-mobile-carousel') && window.matchMedia(MOBILE_MEDIA_QUERY).matches;
  }

  function equalizeCardText(root) {
    var titles = [].slice.call(root.querySelectorAll('.vernal-multi-scene-intro__title'));
    var descriptions = [].slice.call(root.querySelectorAll('.vernal-multi-scene-intro__description'));

    if (!shouldEqualizeText(root)) {
      clearMinHeights(titles);
      clearMinHeights(descriptions);
      return;
    }

    equalizeElementsByRow(titles);
    equalizeElementsByRow(descriptions);
  }

  function runTitleEqualize(scope) {
    var roots = scope.matches && scope.matches(SELECTOR) ? [scope] : scope.querySelectorAll(SELECTOR);
    Array.prototype.forEach.call(roots, function (root) {
      bindTitleImageLoads(root);
      equalizeCardText(root);
    });
  }

  function scheduleTitleEqualize() {
    clearTimeout(titleOtherTimer);
    titleOtherTimer = setTimeout(function () {
      runTitleEqualize(document);
    }, 50);
  }

  function scheduleTitleEqualizeFromResize() {
    clearTimeout(titleResizeTimer);
    titleResizeTimer = setTimeout(function () {
      runTitleEqualize(document);
    }, 280);
  }

  function bootTitleEqualize() {
    window.addEventListener('resize', scheduleTitleEqualizeFromResize);
    window.addEventListener('orientationchange', scheduleTitleEqualizeFromResize);
    document.addEventListener('shopify:section:load', scheduleTitleEqualize);
    TITLE_EQUALIZE_MQ.addEventListener('change', scheduleTitleEqualize);

    var afterReady = function () {
      runTitleEqualize(document);
    };
    if (document.fonts && typeof document.fonts.ready !== 'undefined' && typeof document.fonts.ready.then === 'function') {
      document.fonts.ready.then(afterReady).catch(afterReady);
    } else {
      afterReady();
    }
  }

  function VernalMultiSceneIntro(root) {
    this.root = root;
    this.mobileMedia = window.matchMedia(MOBILE_MEDIA_QUERY);
    this.timer = null;
    this.showingHover = false;
    this.autoEnabled = root.dataset.mobileAutoSwitch === 'true';
    this.interval = parseInt(root.dataset.mobileSwitchInterval, 10) || 2000;
    this.loopPause = parseInt(root.dataset.mobileLoopPauseInterval, 10);
    if (isNaN(this.loopPause)) this.loopPause = 1000;
    this.cards = Array.prototype.slice
      .call(root.querySelectorAll('[data-scene-card]'))
      .filter(function (card) {
        return card.dataset.hasHoverImage === 'true';
      });

    this.swiperRoot = root.querySelector('[data-scene-swiper]');
    this.swiperInstance = null;
    this.hasCarousel = root.hasAttribute('data-mobile-carousel') && !!this.swiperRoot;

    this.handleMediaChange = this.onMediaChange.bind(this);
    this.bindEvents();
    this.syncCarousel();
    this.updateAutoplay();
  }

  VernalMultiSceneIntro.prototype.bindEvents = function () {
    if (typeof this.mobileMedia.addEventListener === 'function') {
      this.mobileMedia.addEventListener('change', this.handleMediaChange);
    } else if (typeof this.mobileMedia.addListener === 'function') {
      this.mobileMedia.addListener(this.handleMediaChange);
    }
  };

  VernalMultiSceneIntro.prototype.unbindEvents = function () {
    if (typeof this.mobileMedia.removeEventListener === 'function') {
      this.mobileMedia.removeEventListener('change', this.handleMediaChange);
    } else if (typeof this.mobileMedia.removeListener === 'function') {
      this.mobileMedia.removeListener(this.handleMediaChange);
    }
  };

  VernalMultiSceneIntro.prototype.onMediaChange = function () {
    this.syncCarousel();
    this.updateAutoplay();
  };

  VernalMultiSceneIntro.prototype.destroySwiper = function () {
    if (this.swiperInstance && typeof this.swiperInstance.destroy === 'function') {
      this.swiperInstance.destroy(true, true);
    }
    this.swiperInstance = null;
  };

  VernalMultiSceneIntro.prototype.syncCarousel = function () {
    if (!this.hasCarousel || typeof Swiper === 'undefined') return;

    this.destroySwiper();
    if (!this.mobileMedia.matches) {
      scheduleTitleEqualize();
      return;
    }

    var slides = this.swiperRoot.querySelectorAll('.swiper-slide');
    if (!slides.length) return;

    var prevEl = this.root.querySelector('[data-scene-prev]');
    var nextEl = this.root.querySelector('[data-scene-next]');

    this.swiperInstance = new Swiper(this.swiperRoot, {
      slidesPerView: 'auto',
      spaceBetween: 12,
      speed: 400,
      watchOverflow: true,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      on: {
        init: function () {
          scheduleTitleEqualize();
        },
      },
    });
  };

  VernalMultiSceneIntro.prototype.clearActive = function () {
    this.cards.forEach(function (card) {
      card.classList.remove(ACTIVE_CLASS);
    });
  };

  VernalMultiSceneIntro.prototype.setHoverVisible = function (visible) {
    this.cards.forEach(function (card) {
      card.classList.toggle(ACTIVE_CLASS, visible);
    });
  };

  VernalMultiSceneIntro.prototype.scheduleNext = function () {
    var self = this;
    var delay = this.showingHover ? this.loopPause : this.interval;

    this.timer = window.setTimeout(function () {
      self.timer = null;
      self.showingHover = !self.showingHover;
      self.setHoverVisible(self.showingHover);
      self.scheduleNext();
    }, delay);
  };

  VernalMultiSceneIntro.prototype.start = function () {
    if (this.timer || this.cards.length === 0) return;

    this.showingHover = false;
    this.clearActive();
    this.scheduleNext();
  };

  VernalMultiSceneIntro.prototype.stop = function () {
    if (this.timer) {
      window.clearTimeout(this.timer);
      this.timer = null;
    }
    this.clearActive();
  };

  VernalMultiSceneIntro.prototype.updateAutoplay = function () {
    var shouldPlay = this.autoEnabled && this.mobileMedia.matches;
    if (shouldPlay) {
      this.start();
      return;
    }
    this.stop();
  };

  VernalMultiSceneIntro.prototype.destroy = function () {
    this.stop();
    this.destroySwiper();
    this.unbindEvents();
  };

  function initRoot(root) {
    if (!root || instances.has(root)) return;
    instances.set(root, new VernalMultiSceneIntro(root));
  }

  function destroyRoot(root) {
    var instance = instances.get(root);
    if (!instance) return;
    instance.destroy();
    instances.delete(root);
  }

  function initAll(context) {
    var scope = context || document;
    var roots = scope.matches && scope.matches(SELECTOR) ? [scope] : scope.querySelectorAll(SELECTOR);
    Array.prototype.forEach.call(roots, initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
      bootTitleEqualize();
    });
  } else {
    initAll(document);
    bootTitleEqualize();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
    runTitleEqualize(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyRoot(event.target.querySelector(SELECTOR));
  });
})();
